import moment from "moment";
import { Skeleton, Typography } from "antd";
import hotels from "../../assets/icons/live-hotel.svg";
import Awayagent from "../../assets/icons/away-agent.svg";
import Busyagent from "../../assets/icons/busy-agent.svg";
import Oflineagent from "../../assets/icons/offline-agent.svg";
import Onlineagent from "../../assets/icons/online-agent.svg";
import CallWaiting from "../../assets/icons/call_waiting.svg";

export const nexusDataGrids = [
    {
        title: "Hotel",
        key: "hotel_count",
        Icon: hotels,
        info: "Calling Dashboard Hotels",
    },
    {
        title: "On Call Agents",
        key: "busy_agents_counts",
        Icon: Busyagent,
        info: "On Call Agents",
    },
    {
        title: "Offline Agents",
        key: "offline_agents_counts",
        Icon: Oflineagent,
        info: "Offline Agents",
    },
    {
        title: "Away Agents",
        key: "away_agents_counts",
        Icon: Awayagent,
        info: "Away Agents",
    },
    {
        title: "Online Agents",
        key: "online_agents_counts",
        Icon: Onlineagent,
        info: "Online Agents",
    },
    {
        title: "Calls Waiting",
        key: "call_waiting_counts",
        Icon: CallWaiting,
        info: "Number of waiting calls",
    },
];

export function getStatusEndpoint(agentStatusKey) {
    switch (agentStatusKey) {
        case "busy_agents_counts":
            return {
                endpoint: "getNexusBusyAgents",
                agent_status: 2,
            };
        case "offline_agents_counts":
            return {
                endpoint: "getNexusOfflineAgents",
                agent_status: 5,
            };
        case "away_agents_counts":
            return {
                endpoint: "getNexusAwayAgents",
                agent_status: 3,
            };
        case "online_agents_counts":
            return {
                endpoint: "getNexusOnlineAgents",
                agent_status: 1,
            };
        case "call_waiting_counts":
            return {
                endpoint: "getNexusCallWaitingDetails",
                // agent_status: 1,
            };
        default:
            break;
    }
}

export const getNexusColumns = (
    sortedInfo,
    agent_status,
    selectedTab,
    handleClick = null,
) => {
    if (agent_status != "call_waiting_counts") {
        return [
            {
                title: "Agent Name",
                key: "first_name",
                render: (record) => {
                    return (
                        <Typography.Text>{`${record.first_name} ${record.last_name}`}</Typography.Text>
                    );
                },
                sorter: () => {},
                // defaultSortOrder: "descend",
                sortOrder:
                    sortedInfo.columnKey === "first_name"
                        ? sortedInfo.order
                        : null,
                width: "40%",
            },
            {
                title: "Hotel Name",
                render: (record) => (
                    <>
                        {record?.hotels.map((hotel) => (
                            <div key={hotel.hotel_id}>{hotel.hotel_name}</div>
                        ))}
                    </>
                ),
            },
        ];
    } else {
        let callWaitingColumn = [
            {
                title: "Hotel Name",
                dataIndex: "hotel_name",
                key: "hotel_name",
                sorter: () => {},
                sortOrder:
                    sortedInfo.columnKey === "hotel_name"
                        ? sortedInfo.order
                        : null,
                width: "40%",
                render: (text, record) =>
                    selectedTab && selectedTab === "history" ? (
                        <span
                            onClick={() =>
                                handleClick("call-waiting-history", record)
                            }
                            id={record.hotel_id}
                            data-hotelname={text}
                            style={{ color: "#1890ff", cursor: "pointer" }}
                        >
                            {text}
                        </span>
                    ) : (
                        <span>{text}</span>
                    ),
            },
            {
                title: "Kiosk Nickname",
                dataIndex: "kiosk_nickname",
                key: "kiosk_nickname",
                sorter: () => {},
                sortOrder:
                    sortedInfo.columnKey === "kiosk_nickname"
                        ? sortedInfo.order
                        : null,
                width: "30%",
            },
        ];
        if (selectedTab && selectedTab === "history") {
            callWaitingColumn.push({
                title: "Waiting calls",
                dataIndex: "calls_waiting",
                key: "calls_waiting",
                sorter: () => {},
                sortOrder:
                    sortedInfo.columnKey === "calls_waiting"
                        ? sortedInfo.order
                        : null,
            });
        }
        return callWaitingColumn;
    }
};

export const nexusHotelColumns = [
    {
        title: "Hotel ID",
        dataIndex: "id",
        key: "id",
        sorter: () => {},
    },
    {
        title: "Hotel Name",
        dataIndex: "name",
        key: "name",
        sorter: () => {},
    },
    {
        title: "Street",
        dataIndex: "street",
        key: "street",
        sorter: () => {},
    },
    {
        title: "City",
        dataIndex: "city",
        key: "city",
        sorter: () => {},
    },
    {
        title: "State",
        dataIndex: "state",
        key: "state",
        sorter: () => {},
    },
    {
        title: "Zipcode",
        dataIndex: "zipcode",
        key: "zipcode",
        sorter: () => {},
    },
];

export const LoadingComponent = () => {
    return (
        <Skeleton active title={false} paragraph={{ rows: 10, width: 40 }} />
    );
};

export const calculateWaitingTime = (record) => {
    const startTime =
        record.call_start_at_kiosk_time || record.call_start_at_staff_time;

    if (!startTime || !record.missed_call_at) return "-";
    const start = moment(startTime);
    const end = moment(record.missed_call_at);
    const diffSeconds = end.diff(start, "seconds");

    const hours = Math.floor(diffSeconds / 3600);
    const minutes = Math.floor((diffSeconds % 3600) / 60);
    const seconds = diffSeconds % 60;

    let formattedTime = "";
    if (hours > 0) {
        formattedTime += `${hours}h `;
    }
    if (minutes > 0) {
        formattedTime += `${minutes}m `;
    }
    formattedTime += `${seconds}s`;

    return formattedTime.trim();
};

export  const getDateTimeRangeOptions = () => ({
    Today: [moment().startOf("day"), moment()],
    Yesterday: [moment().subtract(1, "day").startOf("day"), moment().subtract(1, "day").endOf("day")],
    "Last 15 Minutes": [moment().subtract(15, "minutes"), moment()],
    "Last 30 Minutes": [moment().subtract(30, "minutes"), moment()],
    "Last 1 Hour": [moment().subtract(1, "hour"), moment()],
    "Last 3 Hours": [moment().subtract(3, "hours"), moment()],
    "Last 7 Days": [moment().subtract(7, "days"), moment()],
    "Last 30 Days": [moment().subtract(30, "days"), moment()],
    "Current Month": [moment().startOf("month"), moment()],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
    "Last 3 Months": [moment().subtract(3, "months"), moment()],
  });
